import React from "react";
import SocialIcons from "./SocialIcons";
import "../styles/footer.css";

const Footer = ({ isActive = () => false, handleAnimateLink = (e) => {} }) => {
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer>
      <div
        className="background-image"
        style={{ background: "url('/assets/img/footer1.png') center center / cover" }}
      />
      <div className="top-fade" />
      <div className="left-fade" />

      <div className="footer-inner">
        {/* Cụm trái: logo + mail */}
        <div className="footer-brand">
          <div className="brand-row">
            <img src="/assets/img/logo.png" height="30" alt="logo" />
          </div>
          <a href="mailto:tthtung274@gmail.com" className="mail">
            tthtung274@gmail.com
            <span className="mail-arrow">↗</span>
          </a>
        </div>

        {/* Cụm phải: Navigate dọc */}
        <div className="footer-nav-col">
          <h4 className="col-title">Navigate</h4>
          <ul className="footer-nav">
            <li className={isActive("/") ? "active" : ""}>
              <a href="/" onClick={(e) => handleAnimateLink(e, "/")}>Home</a>
            </li>
            <li className={isActive("/games") ? "active" : ""}>
              <a href="/games" onClick={(e) => handleAnimateLink(e, "/games")}>Games</a>
            </li>
            <li className={isActive("/about") ? "active" : ""}>
              <a href="/about" onClick={(e) => handleAnimateLink(e, "/about")}>About</a>
            </li>
            <li className={isActive("/contact") ? "active" : ""}>
              <a href="/contact" onClick={(e) => handleAnimateLink(e, "/contact")}>Contact</a>
            </li>
          </ul>
        </div>

        {/* Socials — CHỈ hiện ở mobile */}
        <div className="footer-social">
          <SocialIcons />
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <ul className="credits-row">
            <li>© 2026 Tung</li>
            <li>·</li>
            <li>Game Developer</li>
          </ul>
          <a href="#" className="back-to-top" onClick={scrollToTop} aria-label="Back to top">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <polyline points="19 15 12 8 5 15" fill="none" stroke="#000" strokeMiterlimit="10" />
            </svg>
            <span>Up to top</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;